import { delay } from 'lodash';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import useEmitter from './useEmitter';
import { useEvent } from './useEvent';
export const useContentAI = () => {
    const parentEmitter = inject('emitter');
    const { sendNotification } = useEvent();
    const { t } = useI18n();
    const emitter = useEmitter();
    const openImageGenerationForm = () => {
        parentEmitter.emit('image-ai-generate', { source: 'media_library' });
        parentEmitter.emit('closeMediaModal', true);
    };
    const updateSelectedImageAIVariation = (id) => {
        if (id) {
            sendNotification({
                type: 'success',
                duration: 5000,
                title: t('common.successfullyAdded'),
            });
            delay(() => {
                emitter.emit('updateUI');
            }, 3000);
        }
    };
    return {
        openImageGenerationForm,
        updateSelectedImageAIVariation,
    };
};
